function dm_nav(){
    const $navbarToggler = $('.navbar-toggler'),
        $otherNav = $('#otherNav'),
        $mainNav = $('#mainNav'),
        $body = $('body'),
        $navbar = $('header .navbar'),
        $navbarNav = $mainNav.find('.navbar-nav'),
        $navbarNav_links = $navbarNav.find('li.nav-item > a'),
        $nav_links = $mainNav.find('a.nav-link'),
        $navBackBtn = $mainNav.find('a.back');

    // compute mobile state at time-of-use
    const isMobile = () => window.matchMedia('(max-width: 991.98px)').matches;

    console.log('>> nav init', { is_mobile: isMobile() });

    $navbarToggler.on('click', function () {
        $(this).toggleClass('is-active');
         if (!isMobile()){
             $otherNav.toggleClass('d-none').toggleClass('show-other');
         }
        $mainNav.toggleClass('show-other')
        $navbar.toggleClass('open');
        $body.toggleClass('menu-open');
    });

    // Attach hover handlers only on devices that support hover (desktop)
    if ( window.matchMedia('(hover: hover) and (pointer: fine)').matches ) {
        $navbarNav_links
            .on('mouseenter', function (e) {
                if ( $mainNav.hasClass('show-other') ){
                    $navbarToggler.trigger('click');
                }
            })
            .on('mouseleave', function (e) {
            });
    }

    $nav_links.on('click', function (e) {
        if (!isMobile()) return;

        // close any open submenus
        $navbarNav.find('.nav-item.is-active').removeClass('is-active');
        $navbarNav.removeClass('show-sub-menu');

        const $li = $(this).parent();
        const has_submenu = $li.find('.sub-menu').length > 0;

        if (has_submenu) {
            // stop the navigation, but DO NOT stop propagation — let the delegated handler handle UI
            e.preventDefault();

            // optional: quick feedback before delegated handler runs
            $li.addClass('is-active');

            // ensure navbar state for slide-in UI (delegated handler will also set show-other/shift-left)
            $navbarNav.addClass('show-sub-menu');

            // DO NOT call e.stopPropagation() or return false here
            return;
        }

        // no submenu: allow normal navigation — close mobile menu
        $navbarToggler.removeClass('is-active');
        $otherNav.removeClass('show-other');
        $mainNav.removeClass('show-other');
        $navbar.removeClass('open');
        $body.removeClass('menu-open');
    });

    $navBackBtn.on('click', function (e) {
        e.preventDefault();
        let $parent = $(this).closest('.nav-item');
        
        if(isMobile()){
            $parent.removeClass('is-active');
            $navbarNav.removeClass('show-sub-menu');
        }
    });


  function initMobileNav() {
    const navList = document.querySelector('.navbar-nav');
    if (!navList) return;

    // open submenu: support first-touch on mobile for parent links with submenus
    navList.addEventListener('touchstart', (ev) => {
      if (!isMobile()) return;
      const a = ev.target.closest('a.nav-link');
      if (!a) return;
      const li = a.closest('li.nav-item');
      if (!li) return;
      const submenu = li.querySelector('.sub-menu');
      if (!submenu) return;

      if (!li.classList.contains('show-sub')) {
        ev.preventDefault();
        ev.stopPropagation();
        li.classList.add('show-sub');
        navList.classList.add('shift-left');
      }
    }, { passive: false });

    // open submenu: delegate clicks on top-level links that have a sub-menu
    navList.addEventListener('click', (ev) => {
      if (!isMobile()) return;
      const a = ev.target.closest('a.nav-link');
      if (!a) return;
      const li = a.closest('li.nav-item');
      if (!li) return;

      const submenu = li.querySelector('.sub-menu');
      if (!submenu) return;

      console.log('>> navList click (submenu)', { isMobile: isMobile(), target: ev.target, li });

      ev.preventDefault();
      ev.stopPropagation(); // prevent Bootstrap / other listeners from closing menu
      li.classList.add('show-sub');
      navList.classList.add('shift-left');
    });

    // back button inside sub-menu should close it
    navList.addEventListener('click', (ev) => {
      const back = ev.target.closest('.sub-menu .back, .sub-menu .btn.back');
      if (!back) return;
      ev.preventDefault();
      ev.stopPropagation();
      const sub = back.closest('.sub-menu');
      const parentLi = sub && sub.closest('li.nav-item');
      if (parentLi) parentLi.classList.remove('show-sub');
      navList.classList.remove('shift-left');
    });

    // when the navbar collapse is closed, ensure classes reset
    const toggler = document.querySelector('.navbar-toggler');
    if (toggler) {
      toggler.addEventListener('click', () => {
        // collapse toggle — if we are closing the menu, remove submenu states
        // rely on bootstrap collapse classes to check open/close
        setTimeout(() => {
          if (!document.querySelector('#mainNav')?.classList.contains('show')) {
             // menu closed
             document.querySelectorAll('.navbar-nav.shift-left').forEach(el => el.classList.remove('shift-left'));
             document.querySelectorAll('.navbar-nav li.show-sub').forEach(li => li.classList.remove('show-sub'));
           }
         }, 350);
       });
     }

    // remove states on resize to desktop
    window.addEventListener('resize', () => {
      if (!isMobile()) {
         document.querySelectorAll('.navbar-nav.shift-left').forEach(el => el.classList.remove('shift-left'));
         document.querySelectorAll('.navbar-nav li.show-sub').forEach(li => li.classList.remove('show-sub'));
       }
     });
   }

   if (document.readyState === 'loading') {
     document.addEventListener('DOMContentLoaded', initMobileNav, { once: true });
   } else {
     initMobileNav();
   }


}

export { dm_nav };